import { render, staticRenderFns } from "./profhpwrapper.vue?vue&type=template&id=d6bb3a2e&"
import script from "./profhpwrapper.vue?vue&type=script&lang=js&"
export * from "./profhpwrapper.vue?vue&type=script&lang=js&"
import style0 from "./profhpwrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports